// extracted by mini-css-extract-plugin
export default {"sec":"MyCart_sec__RSbmY","pagetitle":"MyCart_pagetitle__1Uq0S","ul":"MyCart_ul__LbOSO","price":"MyCart_price__lqcqH","plus":"MyCart_plus__7u4Fc","equals":"MyCart_equals__eaTq8"};